import * as React from "react";

/**
 * The 12-column verification overlay (styleguide/redesign/SYSTEM.md §2.4).
 *
 * Renders absolutely inside its (relative) parent — a `<Band>` — so the overlay
 * shares the content's exact width basis and its columns land on the content's
 * columns to the pixel (a viewport-fixed overlay drifts by ~scrollbar/2 and
 * lies). Toggled by `?grid=1` in the URL or the `g` key (guarded so typing in
 * an input never trips it). Always mounted, faded via `data-on`; the CSS lives
 * in the app's globals (`.grid-overlay`).
 */
export function GridOverlay() {
  const [on, setOn] = React.useState(false);

  React.useEffect(() => {
    if (new URLSearchParams(window.location.search).get("grid") === "1") {
      setOn(true);
    }
    const onKey = (e: KeyboardEvent) => {
      if (e.key !== "g" && e.key !== "G") return;
      if (e.metaKey || e.ctrlKey || e.altKey) return;
      const t = e.target as HTMLElement | null;
      if (t && (/^(input|textarea|select)$/i.test(t.tagName) || t.isContentEditable)) return;
      e.preventDefault();
      setOn((v) => !v);
    };
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, []);

  return (
    <div className="grid-overlay" data-on={on ? "true" : "false"} aria-hidden>
      <div className="grid-baseline" />
      <div className="grid-field h-full">
        {Array.from({ length: 12 }, (_, i) => (
          <div key={i} className="grid-col">
            <span>{String(i + 1).padStart(2, "0")}</span>
          </div>
        ))}
      </div>
      {on && <div className="grid-badge">12-col · 24px gutter · 8px baseline — press g</div>}
    </div>
  );
}
